import { Thumbnail } from './Thumbnail';
import {Comic} from "./Comic";
import { IpTag } from './IpTag';
import { Creator } from './Creator';
import { FilterTuple } from './FilterTuple';
import { Product } from './Product';
import { isTheChapterProgressFinished } from '../utils/utils';
import { AssetLinkGroup } from './AssetLinkGroup';
import { PublisherRelativeNameSetting } from './Dashboard/Publishers/DashPublisher';

export class BaseSeries {
    id: number;
    title: string = '';
    readableUrl: string
    relativeNameSetting: PublisherRelativeNameSetting;
}

class Series extends BaseSeries {
    description: string = '';
    metaDescription?: string;
    ageRating: string;
    thumbnails: Thumbnail[] = [];
    genres: Genre[] = [];
    publisher?: string = '';
    publisherId?: number;
    publisherBrandURL: string = '';
    tags: string[] = [];
    inMyComics: boolean;
    progress = 0;
    ipTags: IpTag[] = [];
    creators: Creator[] = [];
    completionStatus: string = '';
    assetLinkGroups: AssetLinkGroup[];
    originalLanguageTitle: string = '';
    romanizedTitle: string = '';
    altTitles: string = '';
    /**
     * Check allTypes table: 2-Manga, 4-Strips, 5-Comics, 6-Bandes Dessinees
     */
    type: number

    products: Product[]; //Should be manually set.

    /**
     * Last is usually the biggest.
     */
    getLastThumbnail() {
        if(this.thumbnails.length == 0) {
            return null;
        }
        return this.thumbnails[this.thumbnails.length-1];
    }

    constructor(title?: string, description?: string) {
        super();
        this.title = title;
        this.description = description;
        this.inMyComics = false;
        this.genres = [];
    }

    getFirstFreeChapter(): Product | undefined {
        return (this.products || []).flatMap((product) => product.chapters || [])
            .find((chapter) => chapter.variants?.some((variant) => variant.priceType === 'Free'));
    }

    findFreeChapters(products: Product[], isLoggedIn): Product {
        return (this.products || []).find(p => {
            return p.chapters?.find(c => (c.variants[0]?.priceType === 'Free' || (isLoggedIn && c.variants[0]?.priceType === 'FreeForRegistered')) && isTheChapterProgressFinished(c));
        })?.chapters.find(c => (c.variants[0]?.priceType === 'Free' || (isLoggedIn && c.variants[0]?.priceType === 'FreeForRegistered')) && isTheChapterProgressFinished(c));
    }

    onlyHasBooks(): boolean {
        if(this.products?.length === undefined) {
            return false;
        }
        // return (this.products.every(product => product.subCategory === 'Book') ?? 0) === 0;
        return this.products.every(product => product.subCategory === 'Book');
    }

    isMostlyBooks(): boolean {
        if(this.products?.length ?? 0 == 0) {
            return false;
        }
        return this.products.filter(product => product.subCategory === 'Book').length > this.products.length/2;
    }

    attachProducts(products: Product[]): Series {
        const newSeries = Object.assign(new Series(), this, {
            products: products
        });

        for (let i = 0; i < newSeries.products.length; i++) {
            newSeries.products[i] = Object.assign(new Product(), newSeries.products[i], {
                series: newSeries
            });
        }

        return newSeries;
    }
}

class Genre
{
    name: string;
    id: number;
    title: string;

    ToFilterTuple(){
        const tuple = new FilterTuple();
        tuple.title = this.name;
        tuple.id = this.id;
        return tuple;
    }
}

class SeriesComics {
    id: number;
    comics: Comic[];
}

function seriesTypeToString(t:number){
    switch (t){
        case 4:
            return 'Episode';
        default:
            return 'Volume';
    }
}

export { Series, SeriesComics, Genre, seriesTypeToString };
